import React from 'react';

const Banner = () => {
    return (
        <div>
            <img src="https://www.pinnacletours.in/images/destinations/world.jpg" alt="banner" width="100%" height="150px" />
        </div>
    );
};

export default Banner;